export default "__VITE_ASSET__CozCmVwo__"